import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import WidgetsController from '../../../controllers/WidgetsController';

const TabComponent: React.FC = () => {
  const controller = useController(WidgetsController);

  const widget = controller.activeVotingSessionWidget;
  if (!widget) return null;

  return (
    <aha-sidepanel-item>
      <i className='aha-icon aha-icon-voting' />
    </aha-sidepanel-item>
  );
};

export default ApplicationView(TabComponent);
